import React, { useState, useEffect } from "react";  // Make sure to include useEffect
import {RadioButtonInput } from '../../components/FormInitiators';
import DynamicTable2 from "../../components/DynamicTable2";


const ArrearsSeventhForm2 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => {
      return { ...prevState, [key]: rows };
    });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">

        <label>
              First Increment:
              <RadioButtonInput
                value={formData.firstIncrement} 
                onChange={handleInputChange}
                name="firstIncrement"  
                orientation="horizontal"  
                options={[
                  { value: 'july', label: 'July' },
                  { value: 'jan', label: 'January' }
                ]}    
              />
        </label>

      {/* Dynamic Tables */}
      <DynamicTable2
        tableName="Due Salary Details"
        columns={[
          { header: "Date",name:"basicPay", key: "date", type: "date",  disableFirstRow: true },
          { header: "Basic Pay",name:"basicPay", key: "basicPay", type: "number" },
          { header: "Pay Level", 
            key: "payLevel", 
            type: "dropdown", 
            options: [
              "S-1", "S-2", "S-3", "S-4", "S-5", "S-6", "S-7", "S-8", "S-9", "S-10", "S-11", "S-12", 
              "S-13", "S-14", "S-15", "S-16", "S-17", "S-18", "S-19", "S-20", "S-21", "S-22", "S-23", "S-24", 
              "S-25", "S-26", "S-27", "S-28", "S-29", "S-30", "S-31",
              "AL-10", "AL-11", "AL-12", "AL-13A", "AL-14", "AL-15"
            ] 
          }
          
        ]}
        localStorageKey="dueSalaryDetails"
        rows={formData.dueSalaryDetails}  
        onTableDataChange={onTableDataChange("dueSalaryDetails")}

      />

      <DynamicTable2
        tableName="Drawn Salary Details"
        columns={[
          { header: "Date",name:"basicPay", key: "date", type: "date",  disableFirstRow: true  },
          { header: "Basic Pay",name:"basicPay", key: "basicPay", type: "number" },
          { header: "Pay Level", 
            key: "payLevel", 
            type: "dropdown", 
            options: [
              "S-1", "S-2", "S-3", "S-4", "S-5", "S-6", "S-7", "S-8", "S-9", "S-10", "S-11", "S-12", 
              "S-13", "S-14", "S-15", "S-16", "S-17", "S-18", "S-19", "S-20", "S-21", "S-22", "S-23", "S-24", 
              "S-25", "S-26", "S-27", "S-28", "S-29", "S-30", "S-31",
              "AL-10", "AL-11", "AL-12", "AL-13A", "AL-14", "AL-15"
            ] 
          }
        ]}
        localStorageKey="drawnSalaryDetails"
        rows={formData.drawnSalaryDetails}  
        onTableDataChange={onTableDataChange("drawnSalaryDetails")}

      />
      
      <DynamicTable2
        tableName="HRA Details"
        columns={[
          { header: "Date", key: "date", type: "date",  disableFirstRow: true},
          { header: "City", key: "city", type: "dropdown", options: ["X", "Y", "Y-Nagpur", "Z", "None"] },
          { header: "Is TRA Applicable", key: "TRA", type: "checkbox", defaultValue: true}
        ]}
        localStorageKey="hraDetails"
        rows={formData.hraDetails}  
        onTableDataChange={onTableDataChange("hraDetails")}
      />
 
     
      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default ArrearsSeventhForm2;
